import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {LocalStorageService, UtilService} from "library";
import {LocalStorageKey} from "../../../enums";
import {OptionPointSales} from "../../../enums/option-point-sales";

@Component({
  selector: 'app-sales-point-sale',
  templateUrl: './sales-point-sale.component.html',
})

export class SalesPointSaleComponent implements OnInit{
  @Output() nextStepEvent = new EventEmitter();
  visibleModal = false;
  storeConfig: any;
  typePointSales: any;

  private readonly utilService = inject(UtilService);
  private readonly localStorageService = inject(LocalStorageService);

  constructor() {
  }

  ngOnInit() {
    this.storeConfig = this.localStorageService.get(LocalStorageKey.data).store.setting;
    this.typePointSales = this.storeConfig.type_point_sales;

    if(this.typePointSales === OptionPointSales.ninguno){
      this.onNextStep();
    }
  }

  onNextStep() {
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  protected readonly OptionPointSales = OptionPointSales;
}
